import type { LibraryClientsEditLtiIntegrationsPlatformModel } from '@efdigital/ll-admin-v2/routes/library/clients/client/edit/lti-integrations/platform';
import Route from '@ember/routing/route';

export default class LibraryClientsClientEditLtiIntegrationsPlatformToolRoute extends Route<LibraryClientsEditLtiIntegrationsPlatformModel> {
  model(): LibraryClientsEditLtiIntegrationsPlatformModel {
    return this.modelFor(
      'library.clients.client.edit.lti-integrations.platform'
    ) as LibraryClientsEditLtiIntegrationsPlatformModel;
  }
}
